<template>
  <div id="footer" :class="{'selfStyle': selfStyle}">
    <div class="part1">
      <div><router-link to="/Contact">{{ $t('contact') }}</router-link><span class="line"></span></div>
      <div><router-link to="/Resource">{{ $t('resources') }}</router-link><span class="line"></span></div>
      <div><a :href="openapiHref" target="_blank">{{ $t('openapi') }}</a></div>
    </div>
    <div class="copyright-for-phone">Copyright &copy; Crait Corp. All Rights Reserved.</div>
    <div class="follow-us">
      <span>Follow us</span>
      <a class="facebook cur" href="https://www.facebook.com/craitapp/" target="_blank"></a>
      <a class="twitter cur" href="https://twitter.com/craitapp?lang=e" target="_blank"></a>
    </div>
    <div class="copyright">Copyright &copy; Crait Corp. All Rights Reserved.</div>
  </div>
</template>

<script>
import { getHost } from '../utils.js'
export default {
  name: 'footer',
  prop: {
    footerMt: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      openapiHref: '',
      selfStyle: false
    }
  },
  watch: {
    '$route' (val) {
      setTimeout(() => {
        if (val.path === '/Prices' || val.path === '/download') {
          this.selfStyle = true
        } else {
          this.selfStyle = false
        }
      }, 500)
    }
  },
  mounted () {
    // https://openapi.bat.chat
    this.openapiHref = getHost('openapi')
  }
}
</script>

<style lang="scss">
.selfStyle {
  position: absolute;
  bottom: 0;
}
#footer {
  clear: both;
  overflow: hidden;
  zoom: 1;
  font-size: .16rem;
  /*background-color: #eee;*/
  background-color: #303030;
  text-align: center;
  padding: 0.2rem 3.1rem;
  // position: absolute;
  width: 100%;
  // top: 100;
  min-width: 1300px;
  font-family: PingFang SC;
  /*@media screen and (min-width: 760px) and (max-width: 1440px) {*/
    /*padding: .1rem .6rem;*/
  /*}*/
  @media screen and (max-width: 1600px) {
    padding: .3rem 1.5rem;
    @media screen and (max-width: 760px){
      position: initial;
      padding: 0.3rem 0.2rem;
      min-width: 0;
      background: #fff;
    }
  }
  .cur {
    cursor: pointer;
  }
  .part1 {
    float: left;
    margin-top: .05rem;
    > div {
      display: inline-block;
      a {
        color: rgba(255,255,255,0.8);
        text-decoration: none;
        vertical-align: middle;
      }
      .line {
        display: inline-block;
        width: 1px;
        height: 16px;
        background: #fff;
        margin: 0 30px;
        vertical-align: middle;
        @media screen and (max-width: 760px){
          background: #323232;
          margin: 0 25px;
        }
        @media screen and (max-width: 350px){
          margin: 0 15px;
        }
      }
    }
    @media screen and (max-width: 760px){
      float: none;
      font-size: .15rem;
      > div {
        a {
          color: #333;
        }
      }
    }
  }
  .follow-us {
    float: right;
    color: rgba(255,255,255,0.8);
    font-family: "Helvetica Neue";
    @media screen and (max-width: 760px){
      float: none;
      color: #323232;
    }
    a {
      width: 0.32rem;
      height: 0.32rem;
      display: inline-block;
    }
    .facebook {
      background: url("../assets/images/new/facebook.png") no-repeat center;
      background-size: cover;
      margin: 0 10px;
    }
    .twitter {
      background: url("../assets/images/new/Twitter.png") no-repeat center;
      background-size: cover;
      margin: 0 10px;
    }
  }
  .follow-us > * {
    vertical-align: middle;
  }
  .copyright-for-phone {
    display: none;
    height: 0.35rem;
    line-height: 0.35rem;
    color: rgba(255,255,255,0.8);
    font-family: "Helvetica Neue";
    @media screen and (max-width: 760px){
      display: block;
      float: none;
      font-size: .15rem;
      margin: .3rem 0 .22rem;
      color: #323232;
    }
    @media screen and (max-width: 350px){
      line-height: .2rem;
    }
  }
  .copyright {
    /*float: right;*/
    height: 0.35rem;
    line-height: 0.35rem;
    color: rgba(255,255,255,0.8);
    @media screen and (max-width: 760px){
      /*float: none;*/
      /*font-size: .15rem;*/
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?7bf80e8a